import { Input, Footer } from '@bpinternal/ui-kit-next'
import { useRouter } from '@tanstack/react-router'
import { useState } from 'react'
import { useCreateWorkspace } from '~/hooks'
import { cn } from '~/utils'

type Props = {
  close: () => void
}

export const CreateWorkspaceDialog = ({ close }: Props) => {
  const { mutate: createWorkspace, isPending } = useCreateWorkspace()

  const [value, setValue] = useState<string>()
  const [isValid, setIsValid] = useState<boolean>(false)
  const [error, setError] = useState<string | undefined>(undefined)

  const navigate = useRouter().navigate

  return (
    <div className="flex flex-col gap-2">
      <span>This is the name you will see in your workspace list.</span>
      <Input
        value={value || ''}
        onChange={(e) => {
          const name = e.target.value
          setValue(name)
          setIsValid(name.trim().length > 0)
          setError(undefined)
        }}
        className={cn(error && 'border-red-7 bg-red-2')}
        placeholder="Workspace name"
        autoFocus
      />
      {error && <p className="text-red-8">{error}</p>}
      <Footer
        disabled={!isValid}
        loading={isPending}
        showCancel
        onCancel={() => {
          close()
        }}
        confirmLabel="Create"
        onConfirm={() => {
          if (!value) return

          createWorkspace({
            name: value,
            onSuccess: (workspace) => {
              navigate({ to: '/workspaces/$workspaceId', params: { workspaceId: workspace.id } })
              close()
            },
            onError: (err) => {
              setError(err.message)
            },
          })
        }}
      ></Footer>
    </div>
  )
}
